'use client'

import * as SwitchPrimitives from '@radix-ui/react-switch'
import * as React from 'react'
import { cn } from '@/lib/styles'

interface SwitchProps extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
	labelLeft?: string
	labelRight?: string
}

const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, SwitchProps>(
	({ className, labelLeft, labelRight, ...props }, ref) => (
		<div className="flex items-center space-x-2">
			{labelLeft && (
				<span
					className={cn(
						'text-xl leading-15 text-neutral-dark-600',
						!props.checked && 'font-bold text-brand-black',
					)}
				>
					{labelLeft}
				</span>
			)}
			<SwitchPrimitives.Root
				className={cn(
					'peer inline-flex h-9 w-18 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent  transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-brand-black data-[state=unchecked]:bg-neutral-light-500 outline-none ',
					className,
				)}
				{...props}
				ref={ref}
			>
				<SwitchPrimitives.Thumb className="pointer-events-none block size-5.5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-10.5 data-[state=unchecked]:translate-x-1.5" />
			</SwitchPrimitives.Root>
			{labelRight && (
				<span
					className={cn(
						'text-xl leading-15 text-neutral-dark-600',
						props.checked && 'font-bold text-brand-black',
					)}
				>
					{labelRight}
				</span>
			)}
		</div>
	),
)

Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
